import React from "react";
import { Stack, Typography } from "@mui/material";

import HistoryEvent from "./HistoryEvent";
import { StyledTimeline } from "./styles";

export const HistoryTimeline = ({
  history = [],
  getStageLabel = () => "Unknown",
  getStageFlow = () => "grey",
}) => {
  if (!history.length) {
    return (
      <Typography variant="caption" fontSize={11} color="text.secondary">
        No history yet
      </Typography>
    );
  }

  return (
    <StyledTimeline>
      {history.map((entry) => (
        <HistoryEvent
          key={entry.id}
          entry={entry}
          getStageLabel={getStageLabel}
          getStageFlow={getStageFlow}
        />
      ))}
    </StyledTimeline>
  );
};

export default HistoryTimeline;
